import { createAction, props } from "@ngrx/store";

export const denoteSettingType = `[Workspace] Setting denoted`;

export const denoteSetting = createAction(denoteSettingType, props<any>());
